import { Resource, SearchResourcesThatCanTakeTask } from '../domain/entities'
import { ReAssignaDataRepository } from '../domain/re-assign-data.repository'
import { convertArraySnakeCaseToCamelCaseProperties } from '../../../kernel/mappers'
import { AvtGateway, HttpRequest } from '../../../kernel/avt.gateway'

export const reAssignTaskByResourceIdRepository: ReAssignaDataRepository = {
  reAssignResourceById: async ({ taskId, resourceId }) => {
    const request: HttpRequest = {
      method: 'POST',
      endpoint: `/odin/api/tasks/${taskId}/re-assignation-by-resource/${resourceId}`
    }

    const result = await AvtGateway.executePostRequest(request)

    const message: string = result['message']

    return message
  },
  getResoucesCanTakeTask: async (taskId, quotaless, filters: SearchResourcesThatCanTakeTask) => {
    const request: HttpRequest = {
      method: 'GET',
      endpoint: `/nebula/resources/can-take-task/v2/${taskId}`,
      queryParams: {
        quotaless: quotaless,
        limit: filters.pagination.limit,
        offset: filters.pagination.offset,
        store_id: filters.query.storeId
      }
    }

    if (filters.query.name) {
      request.queryParams['name'] = filters.query.name
    } else if (filters.query.phone) {
      request.queryParams['phone'] = filters.query.phone
    } else if (filters.query.vehicleLabel) {
      request.queryParams['vehicle_label'] = filters.query.vehicleLabel
    } else if (filters.query.storeId) {
      request.queryParams['store_id'] = filters.query.storeId
    }

    const result = await AvtGateway.executeGetRequest(request)

    const resources: Resource[] = convertArraySnakeCaseToCamelCaseProperties(result['resources'])
    const numberOfPages: number = result['number_of_pages']

    return { resources, numberOfPages }
  }
}
